import {
  FREIGHT_CLASS,
  PACKAGE_TYPE,
  EXPEDIET_PACKAGE_TYPE,
} from "../../../utils/constants";
import { ORDER_MANAGEMENT_MESSAGES } from "../../../utils/message";

export const tableConfig = {
  columns: [
    { header: "S.", key: "serial", className: "count", count: true },
    {
      header: "Description",
      key: "description",
      className: "dark",
      sortable: true,
      type: "text",
      mandatory: true,
    },
    {
      header: "Handling Unit",
      key: "handlingUnit",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Quantity",
      key: "quantity",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Weight (lbs)",
      key: "weight",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Item Dimension",
      key: "itemDimension",
      className: "threeRow",
      children: [
        { key: "length", header: "L", type: "number" },
        { key: "width", header: "W", type: "number" },
        { key: "height", header: "H", type: "number" },
      ],
    },
    {
      header: "Unit",
      key: "unit",
      className: "dark",
      type: "text",
      dropdown: true,
      dropdownData: [{ id: "IN", name: "IN" }],
    },
    {
      header: "Item Class",
      key: "itemClass",
      className: "dark",
      // type: "text",
      // mandatory: true,
      dropdown: true,
      dropdownData: FREIGHT_CLASS,
    },
    {
      header: "Comments",
      key: "comments",
      className: "dark",
      type: "text",
    },
    {
      header: "NMFC#",
      key: "nmfc",
      className: "dark",
      type: "text",
    },
    {
      header: "Package Type",
      key: "packageType",
      className: "dark",
      // type: "text",
      mandatory: true,
      dropdown: true,
      dropdownData: EXPEDIET_PACKAGE_TYPE,
    },
    {
      header: "Stack",
      key: "stackable",
      className: "dark",
      dropdown: true,
      dropdownData: [
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" },
      ],
    },
    {
      header: "Hazmat#",
      key: "hazmat",
      className: "hazmat",
    },
  ],
  columnsLTL: [
    { header: "S.", key: "serial", className: "count", count: true },
    {
      header: "Description",
      key: "description",
      className: "dark",
      sortable: true,
      type: "text",
      mandatory: true,
    },
    {
      header: "Handling Unit",
      key: "handlingUnit",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Quantity",
      key: "quantity",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Weight (lbs)",
      key: "weight",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Item Dimension",
      key: "itemDimension",
      className: "threeRow",
      mandatory: true,
      children: [
        { key: "length", header: "L", type: "number" },
        { key: "width", header: "W", type: "number" },
        { key: "height", header: "H", type: "number" },
      ],
    },
    {
      header: "Unit",
      key: "unit",
      className: "dark",
      type: "text",
      dropdown: true,
      dropdownData: [{ id: "IN", name: "IN" }],
    },
    {
      header: "Item Class",
      key: "itemClass",
      className: "dark",
      // type: "text",
      mandatory: true,
      dropdown: true,
      dropdownData: FREIGHT_CLASS,
    },
    {
      header: "Comments",
      key: "comments",
      className: "dark",
      type: "text",
    },
    {
      header: "NMFC#",
      key: "nmfc",
      className: "dark",
      type: "text",
    },
    {
      header: "Package Type",
      key: "packageType",
      className: "dark",
      // type: "text",
      mandatory: true,
      dropdown: true,
      searchable: true,
      dropdownData: PACKAGE_TYPE,
    },
    {
      header: "Stack",
      key: "stackable",
      className: "dark",
      dropdown: true,
      dropdownData: [
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" },
      ],
    },
    {
      header: "Hazmat#",
      key: "hazmat",
      className: "hazmat",
    },
    {
      header: "Linear Feet",
      key: "linearFeet",
      className: "disabled",
      type: "text",
    },
  ],
  columnsExpediet: [
    { header: "S.", key: "serial", className: "count", count: true },
    {
      header: "Description",
      key: "description",
      className: "dark",
      sortable: true,
      type: "text",
      mandatory: true,
    },
    {
      header: "Handling Unit",
      key: "handlingUnit",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Quantity",
      key: "quantity",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Weight (lbs)",
      key: "weight",
      className: "dark",
      type: "number",
      mandatory: true,
    },
    {
      header: "Item Dimension",
      key: "itemDimension",
      className: "threeRow",
      children: [
        { key: "length", header: "L", type: "number" },
        { key: "width", header: "W", type: "number" },
        { key: "height", header: "H", type: "number" },
      ],
    },
    {
      header: "Unit",
      key: "unit",
      className: "dark",
      type: "text",
      dropdown: true,
      dropdownData: [{ id: "IN", name: "IN" }],
    },
    {
      header: "Item Class",
      key: "itemClass",
      className: "dark",
      // type: "text",
      mandatory: true,
      dropdown: true,
      dropdownData: FREIGHT_CLASS,
    },
    {
      header: "Comments",
      key: "comments",
      className: "dark",
      type: "text",
    },
    {
      header: "NMFC#",
      key: "nmfc",
      className: "dark",
      type: "text",
    },
    {
      header: "Package Type",
      key: "packageType",
      className: "dark",
      mandatory: true,
      dropdown: true,
      dropdownData: EXPEDIET_PACKAGE_TYPE,
    },
    {
      header: "Stack",
      key: "stackable",
      className: "dark",
      dropdown: true,
      dropdownData: [
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" },
      ],
    },
    {
      header: "Hazmat#",
      key: "hazmat",
      className: "hazmat",
    },
  ],
  delete: {
    apiUrl: "",
    urlID: "id",
    successMessage: ORDER_MANAGEMENT_MESSAGES.ITEM_DETAIL_DELETE_SUCCESS,
    heading: "Delete item detail!",
    para: "item detail",
  },
};

export interface DataTypes {
  weightUnit?: any;
  id: string;
  serial: number;
  description: string;
  handlingUnit: string;
  quantity: number | string;
  weight: number | string;
  itemDimension: {
    length: number | string;
    width: number | string;
    height: number | string;
  };
  package?: packageDetails[];
  unit: string | object;
  itemClass: string;
  comments: string;
  nmfc: string;
  skuNumber: string;
  packageType: string;
  stackable: string | object;
  hazmat: boolean;
  linearFeet?: string;
}

interface packageDetails {
  quantity: string;
  weight: string;
  length: string;
  width: string;
  heigh: string;
  itemClass: string;
  nmfc: string;
  description: string;
}

// Interface for fields state
export interface Fields {
  quoteDetailId?: any;
  finalMileSource?: any;
  finalmile_quote_id?: any;
  internalLTL?: any;
  orderReference: string;
  orderReference2: string;
  destinationAddress: string;
  destinationAPTSuite: string;
  destinationZipcode: string;
  destinationCity: string;
  destinationState: string;
  destinationCountry: string;
  destinationBusinessLocation: string;
  destinationConsigneeName: string;
  destinationConsigneePhoneNumber: string;
  destinationConsigneePhoneExt: string;
  destinationConsigneeContactEmail: string;
  destinationExtramen: string;
  destinationNoOfFlights: string;
  destinationWaitTimeMinutes: string;
  destinationStorage: string;
  destinationHandingUnits: string;
  destinationWeight: string;
  destinationPieces: string;
  destinationSpecialInstructions: string;
  MidStopAddress: string;
  MidStopAPTSuit: string;
  MidStopZipcode: string;
  MidStopCity: string;
  MidStopState: string;
  MidStopCountry: string;
  MidStopContactName: string;
  MidStopPhoneNumber: string;
  MidStopPhoneNumberExt: string;
  MidStopContactEmail: string[];
  agentHubId: string;
  selectedServiceId: string;
  selectedQuoteId: string;
  allQuoteId: string[];
  orderSwapAndExchange: boolean;
  additionalServices: string[];
  removeAndDisposal: boolean;
  OriginAddress: string;
  OriginAPTSuite: string;
  OriginZipcode: string;
  OriginCity: string;
  OriginState: string;
  OriginCountry: string;
  OriginBusinessLocation: string;
  OriginConsigneeName: string;
  OriginConsigneePhoneNumber: string;
  OriginConsigneePhoneExt: string;
  OriginConsigneeContactEmail: string;
  LTLPickupAccessorials: string[];
  PickUpDockName: string;
  PickUpDOckNumber: string;
  PickUpDockDate: string;
  PickUpDockTime: string;
  PickUpDockOpenTime: string;
  PickUpDOckCloseTime: string;
  PickUpDOckNote: string;
  PickUpFCFS: boolean;
  LTLDropAccessorials: string[];
  DropDockName: string;
  DropDOckNumber: string;
  DropDockDate: string;
  DropDockTime: string;
  DropDockOpenTime: string;
  DropDOckCloseTime: string;
  DropDOckNote: string;
  DropFCFS: boolean;
  totalLinearFeet: string;
  totalDensity: string;
  totalCBM: string;
  CarrierName: string;
  serviceCost: string;
  markup: number;
  scac: string;
  costDetails: costDetails[];
  customerMarkupType: string;
  courierPro1?: string;
  courierPro2?: string;
  plProvider?: string;
  distance: string;
  offerId: string;
  productTransactionId: string;
  PickupTargetDateFrom: string;
  PickupTargetDateTo: string;
  PickupTargetTimeFrom: string;
  PickupTargetTimeTo: string;
  PickupDeliveryDateFrom: string;
  PickupDeliveryDateTo: string;
  PickupDeliveryTimeFrom: string;
  PickupDeliveryTimeTo: string;
  AgentHub: {
    id: string;
    name: string;
  };
  originCity: string;
  finalMileDistance: string;
  finalMileCost: string;
  totalDensityView: string;
  totalLinearFeetView: string;
  totalLinearCBMView: string;
  //Final mile box details
  agentName?: string;
  hubName?: string;
  city?: string;
  zipCode?: string;
  country?: string;
  AgentHubId?: string;
  distanceToDestination?: any;
  operationHrsFrom?: any;
  operationHrsTo?: any;
  quotePrice?: any;
  destinationAddressId?: string;
  OriginAddressId?: string;
  quoteId?: string;
  orderFor?: string;
  loadId?: string;
  quoteFrom?: string;
  banyanType?: string;
  parentQuoteId?: string;
  source?: string;
  isProvidence?: boolean;
  carrierQuoteId?: string;
  rateRequestLocator?: string;
  allianceQuoteDetail?: AllianceQuoteDetail;
}

// Values an Alliance quote returns that its LTL order sends back in quoteDetail, unchanged.
export interface AllianceQuoteDetail {
  ServiceLevelID?: string;
  DeliveryDate?: string;
  DeliveryTime?: string;
}

interface costDetails {
  name: string;
  amount: string;
}
// Interface for documentInfo state
export interface DocumentInfo {
  files: { fileUrl: string; fileName: string }[];
  urls: string[];
}

// Interface for Customer Dropdown state
export interface CustomerRowDataType {
  id: string;
  name: string;
  customerNumber: string;
  customerLevel: string | null;
  isUsedOrderReference2?: boolean;
  usedOrderReference2?: string | null;
}
interface ColumnTypes {
  key: string;
  title: string;
}

export interface AgentRowDataType {
  id?: string;
  name: string | null;
  agentType: "";
}

export const customerOrderColumns: ColumnTypes[] = [
  { key: "name", title: "Customer Name" },
  { key: "customerNumber", title: "Number" },
];

export const agentOrderColumns: ColumnTypes[] = [
  { key: "name", title: "Agent Name" },
  { key: "agentType", title: "Agent Type" },
];

export const accessorialsColumn: ColumnTypes[] = [
  { key: "name", title: "Limited Access" },
];

export interface hubData {
  operationFrom: string;
  operationTo: string;
  hubName: string;
}

// Interface for Order Type Dropdown state
export interface OrderTypeRowDataType {
  id?: string;
  name: string | null;
  description: string;
}

export const orderTypeColumns: ColumnTypes[] = [
  { key: "name", title: "Order Type" },
  { key: "description", title: "Description" },
];

// Interface for Form Errors
export interface FormErrorsType {
  [key: string]: string;
}

// Interface for Mandatory Fields
export const orderMandatoryFields: (keyof Fields)[] = [
  "destinationAddress",
  "destinationZipcode",
  "destinationConsigneePhoneNumber",
  "MidStopAddress",
  "MidStopZipcode",
  "destinationConsigneeName",
  "orderReference",
];
export const orderLTLMandatoryFields: (keyof Fields)[] = [
  "destinationAddress",
  "destinationZipcode",
  "destinationConsigneePhoneNumber",
  // "CarrierName",
  // "scac",
  // "offerId",
  // "productTransactionId",
  "OriginBusinessLocation",
  "OriginConsigneeName",
  "OriginConsigneePhoneNumber",
  "destinationBusinessLocation",
  "destinationConsigneeName",
  "destinationAddress",
  "orderReference",
  "OriginAddress",
  "PickUpDockDate",
  "PickUpDockTime",
  "PickUpDockOpenTime",
  "PickUpDOckCloseTime",
  "DropDockOpenTime",
  "DropDOckCloseTime",
];

export const orderLTLFinalMileMandatoryFields: (keyof Fields)[] = [
  "destinationAddress",
  "destinationZipcode",
  "destinationConsigneePhoneNumber",
  // "CarrierName",
  // "scac",
  // "offerId",
  "OriginBusinessLocation",
  "OriginConsigneeName",
  "OriginConsigneePhoneNumber",
  "destinationBusinessLocation",
  // "productTransactionId",
  "destinationConsigneeName",
  "destinationAddress",
  "orderReference",
  "OriginAddress",
  "PickUpDockDate",
  "PickUpDockTime",
  "PickUpDockOpenTime",
  "PickUpDOckCloseTime",
];

export const getQuotesMandatoryFields: (keyof Fields)[] = [
  //"destinationAddress",
  "destinationZipcode",
  //"destinationConsigneePhoneNumber",
  //"destinationConsigneeName",
  //"orderReference",
];

export const orderExpeditedMandatoryFields: (keyof Fields)[] = [
  "destinationAddress",
  "destinationZipcode",
  "destinationConsigneePhoneNumber",
  "destinationConsigneeName",
  "destinationBusinessLocation",
  "orderReference",
  "serviceCost",
  "PickupTargetDateFrom",
  "PickupTargetDateTo",
  "PickupTargetTimeFrom",
  "PickupTargetTimeTo",
  "PickupDeliveryDateFrom",
  "PickupDeliveryDateTo",
  "PickupDeliveryTimeFrom",
  "PickupDeliveryTimeTo",
  "OriginAddress",
  "OriginZipcode",
  "OriginBusinessLocation",
  "OriginConsigneeName",
  "OriginConsigneePhoneNumber",
];

export const getLTLQuotesMandatoryFields: (keyof Fields)[] = [
  "destinationZipcode",
  "PickUpDockDate",
  "PickUpDockTime",
  "OriginZipcode",
];

// Interface for service Level
export interface ServiceLevelType {
  id?: string;
  name: string | null;
}

// interface for Get Quote ApiResponse
interface Service {
  id: string;
  updatedAt?: string;
  createdAt?: string;
  name: string;
  description: string;
  comment?: string | null;
  shortName: string;
  longName: string;
  deliverWithin: number;
  useOver150Lbs: boolean;
  serviceDays: string[];
  dispatchTicketColor?: string;
  dispatchPrinter?: string;
  quoteId: string;
  quotePrice: string;
  distanceToDestination: number;
  totalWeight: number;
  rateDetails: {
    fuelSurcharge: string;
    basePrice: string;
    additionalOtherCharges: any[];
    customerFuelSurcharge: string;
  };
  serviceType: {
    name: string;
  };
}

interface Address {
  id: string;
  updatedAt: string;
  createdAt: string;
  address: string;
  aptSuit: string;
  zipCode: string;
  city: string;
  state: string;
  country: string;
  phoneNumber: string;
  phoneExtension: string;
  businessLocation: string;
  contactPerson: string;
  contactEmail: string;
  operationHrsFrom: string;
  operationHrsTo: string;
  latitude: string;
  longitude: string;
}

interface Agent {
  id: string;
  updatedAt: string;
  createdAt: string;
  name: string;
  phoneNumber: string;
  email: string;
  carrierCode: string;
  avatar: string | null;
  apiInvoicing: boolean;
  apiUseWeightZone: boolean;
  orderMails: boolean;
  totalSolutions: boolean;
  isDeleted: boolean;
  isSignedUp: boolean;
  isPhoneVerified: boolean;
  isActive: boolean;
  agentNumber: string;
}

interface Hub {
  id: string;
  updatedAt: string;
  createdAt: string;
  name: string;
  phoneNumber: string;
  phoneExt: string;
  activeDate: string;
  deactiveDate: string;
  isActive: boolean;
  operationEmail: string[];
  orderMails: boolean;
  services: Service[];
  address: Address;
  agent: Agent;
  masterHubId: string;
}

interface ApiResponse {
  hub: Hub;
  services: Service[];
}

interface LtlApiResponse {
  worldWideQuote: any[];
}

export interface GetQuoteApiResponse {
  hub: Hub;
  masterHub: any;
  services: Service[];
  data: ApiResponse[];
  success: boolean;
}

export interface GetLTLQuoteApiResponse {
  worldWideQuote: any[];
  data: LtlApiResponse[];
  success: boolean;
}

export interface LtlFinalMileApiResponse {
  selectedFinalMileQuote: any;
  ltlPlusFinalMileQuote: any[];
}
export interface GetLTLFinalMileQuoteApiResponse {
  data: LtlFinalMileApiResponse;
  success: boolean;
  selectedFinalMileQuote?: any;
}

export interface MappedService {
  serial: number;
  serviceName: string;
  description: string;
  serviceLevel: string;
}

export interface QuoteInfo {
  agentName: string;
  operationHrsFrom: string;
  operationHrsTo: string;
  hubName: string;
  addressName: string;
  address: Address;
  distanceToDestination?: number;
  quoteSelected?: boolean;
  agentHubId?: string;
  /**
   * Master hub of this specific agent. A multi-service Final Mile quote can return
   * several agents at once, so the master hub has to travel per agent rather than in
   * a single shared piece of page state.
   */
  masterHubName?: string;
  masterHubAddress?: Address;
  /**
   * Whether this agent quotes through a master hub. `false` makes GetQuote show the
   * agent's own hub instead of falling back to the page-level master hub, which holds
   * only the last one in the result set. Callers that don't map master hubs per agent
   * leave it unset and keep that fallback.
   */
  hasMasterHub?: boolean;
}

export interface MoreReferencesType {
  referenceCount: number;
  referenceValue: string;
}

export interface addressField {
  destinationAddress: string;
  destinationAPTSuite: string;
  destinationZipcode: string;
  destinationCity: string;
  destinationState: string;
  destinationCountry: string;
  destinationBusinessLocation: string;
  destinationConsigneeName: string;
  destinationConsigneePhoneNumber: string;
  destinationConsigneePhoneExt: string;
  destinationConsigneeContactEmail: string;
  latitude: string;
  longitude: string;
  countryCallingCode: string
}
